<template>
  <div id="main-content" class="add-bus">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('bus.name') }}</span>
            </el-col>
            <input class="input" v-model="bus_data.name" type=""/>
            <el-col v-if="error_message.name" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.name" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('bus.brand') }}</span>
            </el-col>
            <input class="input" v-model="bus_data.brand" type=""/>
            <el-col v-if="error_message.brand" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.brand" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('bus.form') }}</span>
            </el-col>
            <select style="" class="input" v-model="bus_data.layout_id">
              <option value="">{{ $t('common.please_select') }}</option>
              <option v-for="layout in busLayoutList" :key="layout.id" :value="layout.id">{{ `${layout.name}, ${$t('bus.total_seats')}: ${layout.total_seats}` }} </option>
            </select>
            <el-col v-if="error_message.layout_id" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.layout_id" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col :span="12" style="display: inline;">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('bus.total_allowed_seats') }}</span>
            </el-col>
            <input class="input" v-model="bus_data.available_seats" type=""/>
            <el-col v-if="error_message.available_seats" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.available_seats" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('bus.license_plate') }}</span>
            </el-col>
            <select style="" class="input" v-model="bus_data.license_plate">
              <option value="">{{ $t('common.please_select') }}</option>
              <option v-for="plate in plateList" :key="plate" :value="plate">{{ plate }} </option>
            </select>
            <el-col v-if="error_message.license_plate" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.license_plate" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('bus.owner_type') }}</span>
            </el-col>
            <b-form-select
              id="input-3"
              style="width: 60%; float: left"
              v-model="bus_data.ownership_type"
              :options="owner_type"
              required
            ></b-form-select>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.year') }}</span>
            </el-col>
            <input class="input" v-model="bus_data.manufacture_year" type=""/>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.image') }}</span>
            </el-col>
            <b-form-file
              v-model="bus_data.image"
              style="width: 60%; float: left"
              :placeholder="$t('common.choose_file')"
              :drop-placeholder="$t('common.drop_file')"
            ></b-form-file>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('bus.purchase_time') }}</span>
            </el-col>
              <el-date-picker
                  v-model="bus_data.buy_at"
                  type="date"
                  :placeholder="$t('common.pick_a_date')"
                  value-format="yyyy-MM-dd" style="width: 60%; float: left;">
              </el-date-picker>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8"><span class="form-lable">{{ $t('bus.rear_camera') }}</span></el-col>
            <el-col :span="16"><input type="checkbox" v-model="bus_data.has_rear_camera" name="" value="Bike">
            </el-col>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('bus.service_start_time') }}</span>
            </el-col>
            <el-date-picker
                v-model="bus_data.used_at"
                type="date"
                :placeholder="$t('common.pick_a_date')"
                value-format="yyyy-MM-dd" style="width: 60%; float: left;">
            </el-date-picker>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('bus.months_of_service_use') }}</span>
            </el-col>
            <input style="width: 60% !important;" class="input" v-model="monthDiff" disabled="disabled" type="number"/>
          </el-col>
        </el-row>
        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  import {mapState} from 'vuex'

  export default {
    name: "AddBus",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/bus?action=back`,
        title: 'bus.add_bus',
        owner_type: [{text: this.$t('bus.owned'), value: 1}, {text: this.$t('bus.rented'), value: 2}],
        bus_data: {
          name: "",
          brand: "",
          seats: 0,
          available_seats: 0,
          license_plate: "",
          ownership_type: 1,
          buy_at: "",
          has_rear_camera: false,
          manufacture_year: "",
          used_at: "",
          used_month: 0,
          image: null,
          layout_id: ""
        },
        error_message: {
          name: [],
          brand: [],
          available_seats: [],
          license_plate: [],
          layout_id: []
        }
      }
    },
    methods: {
      submitAction: function () {
        var check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push('/bus')
          };
          var formData = new FormData()
          for (const [key, value] of Object.entries(this.bus_data)) {
            if (key === "seats") {
              formData.append(key, this.busLayoutList.find(x => x.id === this.bus_data.layout_id).total_seats)
            } else {
              formData.append(key, value)
            }
          }
          let payload = {
            successCallback,
            data: formData
          }

          this.$store.dispatch('bus/createBus', payload);
        } else {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })
          return false
        }
      },
      validate: function () {
        var check = true
        this.error_message.name = []
        if (this.bus_data.name === "") {
          this.error_message.name.push('* ' + this.$t('bus.bus_name_is_required'))
          check = false
        }

        this.error_message.brand = []
        if (this.bus_data.brand === "") {
          check = false
          this.error_message.brand.push('* ' + this.$t('bus.brand_is_required'))
        }
        this.error_message.layout_id = []
        if (this.bus_data.layout_id === "") {
          check = false
          this.error_message.layout_id.push('* ' + this.$t('bus.form_is_required'))
        }
        this.error_message.available_seats = []
        if (this.bus_data.available_seats == 0) {
          check = false
          this.error_message.available_seats.push('* ' + this.$t('bus.total_allowed_seats_is_required'))
        }

        this.error_message.license_plate = []
        if (this.bus_data.license_plate === "") {
          check = false
          this.error_message.license_plate.push('* ' + this.$t('bus.license_plate_is_required'))
        }

        return check
      }
    },
    mounted: function () {
      this.$store.dispatch('bus/getBusLayoutList',)
      this.$store.dispatch('bus/getAvailablePlateList',)
    },
    computed: {
      ...mapState('bus', ['busLayoutList', 'plateList']),
      monthDiff: function () {
        var months;
        var d1 = new Date(this.bus_data.used_at)
        var d2 = new Date()
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth() + 1;
        months += d2.getMonth();
        if (isNaN(months)) {
          return 0
        }
        return months <= 0 ? 0 : months;
      }
    }
  }
</script>

<style lang="scss">
  .input {
    height: 38px;
    width: 60%;
    font-size: 15px;
    padding: 6px 12px;
    border-radius: 5px;
    border: 1px solid #ced4da;
    float: left;
  }

  .form-control {
    width: 60% !important;
    float: right !important;
  }

  input[type='checkbox'] {
    -webkit-appearance: none;
    width: 28px;
    height: 28px;
    background: white;
    border-radius: 5px;
    border: 2px solid #ced4da;
    float: left;
  }

  input[type='checkbox']:checked {
    background-image: url("../../assets/icon/done-icon.png");
    background-repeat: no-repeat;
    background-size: contain;
  }

  .was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
    border-color: #ced4da !important;
  }
  .custom-file-label{
    white-space: nowrap !important;
    overflow-x: hidden !important;
    text-overflow: ellipsis !important;
  }

  .form-lable {
    line-height: 40px;
    font-size: 18px;
    padding-right: 20px;
    float: left;
    text-align: left;
    font-weight: bold;
  }

</style>
